<div class="sidebar-reference container-fluid p-4"><app-loading [isLoading]="isLoading">
  <div class="row">
    <div class="col-12 col-md-10">
      <tabset type="pills">
        @for (t of tabs; track trackByFn(i, t); let i = $index) {
          <tab [active]="t.isActive" (selectTab)="selectTab(i)"><ng-template tabHeading="tabHeading"><span class="lnr" [ngClass]="t.icon" [tooltip]="t.label | translate" container="body"></span></ng-template></tab>
        }
      </tabset>
    </div>
    <div class="col-12 col-md-2"><button class="btn-close d-block ms-auto me-0" type="button" (click)="close()"></button></div>
  </div>
  @if (reference) {
    <div class="row mt-4">
      <div class="col-12">@if (activeTab === 0) {
        <app-sidebar-reference-question-set [reference]="reference"></app-sidebar-reference-question-set>
        }@if (activeTab === 1) {
        <app-sidebar-reference-activities [reference]="reference"></app-sidebar-reference-activities>
        }@if (activeTab === 2) {
        <app-sidebar-reference-comments [reference]="reference"></app-sidebar-reference-comments>
        }@if (activeTab === 3) {
        <app-sidebar-reference-emails [reference]="reference"></app-sidebar-reference-emails>
        }@if (activeTab === 4) {
        <app-sidebar-reference-texts [reference]="reference"></app-sidebar-reference-texts>
        }@if (activeTab === 5) {
        <app-sidebar-reference-reminders [reference]="reference"></app-sidebar-reference-reminders>
        }@if (activeTab === 6) {
        <app-sidebar-reference-about [reference]="reference"></app-sidebar-reference-about>
      }</div>
    </div>
  }
</app-loading></div>
